/**
 * MobileDesktopHint — bannière mobile uniquement invitant à utiliser
 * l'ordinateur pour configurer une enseigne avec plus de confort.
 *
 * Affichée en haut des configurateurs (Croix, Lettres boîtier, Caducée).
 * Hors layout desktop : ne s'affiche QUE sur mobile (< 768px).
 */
import React from "react";
import { Monitor } from "lucide-react";
import { useI18n } from "../contexts/I18nContext";
import { useIsMobile } from "../hooks/useIsMobile";

const COPY = {
  fr: {
    title: "Configurez votre enseigne sur ordinateur",
    body: "Pour une meilleure expérience et plus de précision sur les détails (police, couleurs, dimensions), nous vous recommandons d'utiliser un ordinateur.",
  },
  de: {
    title: "Konfigurieren Sie Ihr Schild am Computer",
    body: "Für ein besseres Erlebnis und mehr Präzision empfehlen wir die Nutzung eines Computers.",
  },
  en: {
    title: "Configure your sign on a desktop",
    body: "For the best experience and finer control over fonts, colors and dimensions, we recommend using a computer.",
  },
  it: {
    title: "Configura la tua insegna su computer",
    body: "Per un'esperienza migliore e maggiore precisione, consigliamo di usare un computer.",
  },
};

export default function MobileDesktopHint() {
  const { lang } = useI18n();
  const isMobile = useIsMobile();
  if (!isMobile) return null;
  const t = COPY[lang] || COPY.fr;
  return (
    <div
      className="md:hidden mb-4 border border-[#39FF14]/40 bg-[#39FF14]/[0.06] p-4 flex gap-3 items-start"
      data-testid="mobile-desktop-hint"
    >
      <Monitor size={20} className="text-[#39FF14] shrink-0 mt-0.5" />
      <div>
        <p className="font-mono text-[11px] uppercase tracking-widest text-[#39FF14] mb-1">
          {t.title}
        </p>
        <p className="text-sm text-zinc-300 leading-relaxed">{t.body}</p>
      </div>
    </div>
  );
}
